import { ChartTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import type { ChangeData, LobData, VisitsData } from "./types";

const LOB_COLUMN = {
    key: "1",
    get title() {
        return translate("analysis.content.visits.overtime.chart.tooltip.header.1");
    },
    selector: "lob" as const,
    align: "left" as const,
    borderRight: false,
    size: ChartTooltip.LabelCellDefaultWidth,

    render: ({ lob }: { lob: LobData }) => {
        return (
            <ChartTooltip.LabelCell
                label={lob.label}
                backgroundColor={lob.background}
            />
        );
    },
};

const VISITS_COLUMN = {
    key: "2",
    get title() {
        return translate("analysis.content.visits.overtime.chart.tooltip.header.2");
    },
    selector: "visits" as const,
    align: "right" as const,
    borderRight: true,
    size: "80px",
    render: ({ visits }: { visits: VisitsData }) => {
        return <ChartTooltip.ValueCell value={visits.value} />;
    },
};

const CHANGE_COLUMN = {
    key: "3",
    get title() {
        return translate("analysis.content.visits.overtime.chart.tooltip.header.3");
    },
    selector: "change" as const,
    align: "right" as const,
    size: ChartTooltip.ChangeCellDefaultWidth,
    render: ({ change }: { change: ChangeData }) => {
        return (
            <ChartTooltip.ChangeCell
                value={change.value}
                isDecrease={change.isDecrease ?? undefined}
                unsigned={change.unsigned}
            />
        );
    },
};

export const COLUMN_DEFINITION_VISITS_OVERTIME = [LOB_COLUMN, VISITS_COLUMN, CHANGE_COLUMN];
